import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const INITIAL_LOADING_READY_EVENT = 'inspectpro:initial-loading-ready';

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/app.component.scss */
:host {
  display: block;
  min-height: 100%;
  background: #020617;
}

@keyframes appStartupSpin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes appStartupPulse {
  0%, 80%, 100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-4px);
  }
}
.app-startup-loading {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  background: #020617;
}

.app-startup-loading__content {
  width: min(360px, 100%);
  text-align: center;
}

.app-startup-loading__brand {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 2px;
  margin-bottom: 28px;
  font-weight: 800;
}
.app-startup-loading__brand .inspect,
.app-startup-loading__brand .pro {
  font-size: 30px;
  line-height: 1;
}
.app-startup-loading__brand .inspect {
  color: #f8fafc;
}
.app-startup-loading__brand .pro {
  color: #ff6b35;
}

.app-startup-loading__spinner {
  width: 48px;
  height: 48px;
  margin: 0 auto 22px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: #ff6b35;
  border-radius: 50%;
  animation: appStartupSpin 0.9s linear infinite;
  box-sizing: border-box;
}

.app-startup-loading__status {
  margin: 0;
  color: #f8fafc;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 700;
}

.app-startup-loading__hint {
  margin: 8px auto 0;
  max-width: 320px;
  color: #cbd5e1;
  font-size: 13px;
  line-height: 1.6;
  font-weight: 500;
}

.app-startup-loading__dots {
  display: flex;
  justify-content: center;
  gap: 7px;
  margin-top: 18px;
}
.app-startup-loading__dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff6b35;
  animation: appStartupPulse 1.2s ease-in-out infinite;
}
.app-startup-loading__dots span:nth-child(2) {
  animation-delay: 0.16s;
}
.app-startup-loading__dots span:nth-child(3) {
  animation-delay: 0.32s;
}

@media (max-width: 480px) {
  .app-startup-loading {
    padding: 24px;
  }
  .app-startup-loading__brand .inspect,
  .app-startup-loading__brand .pro {
    font-size: 26px;
  }
}`],
})
export class AppComponent implements OnInit, OnDestroy {
    public startupLoading: boolean = true;

    private readonly hideStartupLoadingHandler = () => this.hideStartupLoading();

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        window.addEventListener(INITIAL_LOADING_READY_EVENT, this.hideStartupLoadingHandler, { once: true });
        await this.service.init(this);
        if (this.service.loading && !this.service.loading.isshow) {
            this.hideStartupLoading();
        }
    }

    public ngOnDestroy() {
        window.removeEventListener(INITIAL_LOADING_READY_EVENT, this.hideStartupLoadingHandler);
    }

    private hideStartupLoading() {
        if (!this.startupLoading) return;
        this.startupLoading = false;
        this.ref.detectChanges();
    }
}
